import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';

const initialState = {
  discoverError: null,
  isFetching: false,
};

const reducer = (state = initialState, action) => {
  const payload = action.payload;
  switch (action.type) {
    case types.SSO_ERROR:
      return { ...state, error: getErrorMessage(payload) };
    case types.SSO_DISCOVER_CLEAR:
      return { ...state, discoverError: null, isFetching: false };
    case types.SSO_DISCOVER_ERROR:
      return { ...state, discoverError: true, isFetching: false };
    case types.SSO_DISCOVER_REQUEST:
      return { ...state, discoverError: null, isFetching: true };
    default:
      return state;
  }
};

export default reducer;
